module.exports = __webpack_public_path__ + "img/AI.0630d0cc.png";